// LIBRARIES
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
  SIZE,
} from "constants/variables";
import styled from "styled-components";

// Define the styled components
export const ParentContainer = styled.div`
  margin-top: ${MARGIN.max120};
  width: 100%;
  height: 963px;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.VividAuburn};
  display: flex;
  flex-direction: column;
  padding: ${MARGIN.max80} 0px;
  position: relative;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    height: auto;
  }
`;

export const Title = styled.div`
  margin-bottom: ${MARGIN.max24};
  margin-left: ${MARGIN.max80};
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.max24};

  align-items: center;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: ${MARGIN.max24};
    gap: ${MARGIN.max8};
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-left: ${MARGIN.max80};
  padding-right: ${MARGIN.max80};
  position: relative;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    flex-direction: column;
    padding-left: ${MARGIN.max24};
    padding-right: ${MARGIN.max24};
    gap: ${MARGIN.max40};
    justify-content: center;
    align-items: center;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: auto;
  }
`;

export const CardContainer = styled.div<{
  colSpan: number;
  rowSpan: number;
  isImage?: boolean;
}>`
  grid-column: span ${({ colSpan }) => colSpan};
  grid-row: span ${({ rowSpan }) => rowSpan};
  border-radius: ${BORDER_RADIUS.radius21};
  overflow: hidden;
  background-color: ${COLORS.FaluRed};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${MARGIN.max40};
  position: relative;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CardTitle = styled.h2`
  margin: 0;
  text-align: center;
  max-width: 346px;
`;

export const CardContent = styled.div`
  /* text-align: center; */
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.max24};
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.max4};
`;

export const CardIllustration = styled.img`
  position: absolute;
  top: -107px;
  right: -107px;
  width: 255px;
  height: 255px;
`;

export const SectionIllustration = styled.img`
  position: absolute;
  bottom: -168px;
  right: -168px;
  width: 400px;
  height: 400px;
  rotate: calc(90deg);
  opacity: 0.5;
`;

export const SectionSecondIllustration = styled.img`
  position: absolute;
  left: -173px;
  top: 330px;
  width: 398.75px;
  height: 398.75px;
`;

export const TabsWrapper = styled.div`
  margin-bottom: ${MARGIN.max48};
  width: 100%;
  height: 80px;
`;

export const LeftSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: ${MARGIN.max24};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 100%;
    gap: ${MARGIN.fix16};
  }
`;

export const ImageCard = styled.img`
  width: 705px;
  height: 324px;
  border-radius: ${BORDER_RADIUS.radius24};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 100%;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    height: 224px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: ${MARGIN.fix16};
  gap: ${MARGIN.max24};
  overflow: auto;
  max-height: 596px;
  /* Track */
  ::-webkit-scrollbar-track {
    background: ${COLORS.Background};
    border-radius: ${BORDER_RADIUS.radius8};
    border-radius: ${BORDER_RADIUS.radius8};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.Yellow};
    border-radius: ${BORDER_RADIUS.radius8};
  }
`;

export const Line = styled.div`
  height: 100%;
  width: 2px;
  background-color: #f5f5f552;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    height: 2px;
    width: 100%;
  }
`;

export const RightSideWrapper = styled.div`
  height: 100%;
  max-width: 705px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  /* justify-content: flex-start; TODO when they have documents*/
  justify-content: center;
  margin-left: ${MARGIN.max64};
  gap: ${MARGIN.max24};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    margin-left: 0px;
    flex-direction: column-reverse;
  }
`;

export const ImagesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.max24};
`;

export const Info = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.fix16};
  margin-top: -8px;
`;

export const ButtonContainer = styled.div`
  width: 129px;
  height: 42px;
  border-radius: 21px;
`;

export const SmallImageCard = styled.img`
  width: 100%;
  height: auto;
  border-radius: ${BORDER_RADIUS.radius24};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 130px;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    /* width: 124px;
    height: 94px; */
  }
`;

export const ImagesRow = styled.div`
  width: 100%;
  position: relative;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${MARGIN.fix16};
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ArticleRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  justify-content: center;
`;

export const ArticleContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const ArticleTitleWrapper = styled.div`
  margin-bottom: ${MARGIN.fix16};
  display: flex;
  flex-direction: row;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    margin-bottom: ${MARGIN.max8};
    gap: ${MARGIN.max12};
    width: 55%;
  }
`;

export const ArticleBodyWrapper = styled.div`
  margin-bottom: ${MARGIN.max24};
  max-width: 624px;
`;

export const SkeletonWrapperHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.fix16};
  margin-top: ${MARGIN.max10};
`;
export const FileWrapper = styled.div`
  height: ${SIZE.max100};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    height: auto;
  }
`;
